export const REFETCH_INTERVALS = {
  DEFAULT: 10 * 1000,
  FILE_PROCESSING: 10 * 1000,
};
